'use client';

import React from 'react';
import { trackEvent } from '../google-tag-manager';
import Link from 'next/link';

const PlayDemoCTA: React.FC<{
  className?: string;
  children?: React.ReactNode;
}> = (props) => {
  const { className, children } = props;

  const handleCtaClick = () => {
    trackEvent({
      event: 'play_demo_click'
    });
  };

  return (
    <Link href="/watch-demo/play" className={className ?? 'btn btn-primary btn-outline rounded-full gap-4 border-2 mt-6 w-full sm:w-auto'} onClick={handleCtaClick}>
      {children ?? 'Watch demo'}
    </Link>
  );
};

export default PlayDemoCTA;
